// extracted by mini-css-extract-plugin
export default {"container":"getApp_container__7wT1y","applogo":"getApp_applogo__pWTJ6","linkContainer":"getApp_linkContainer__Wg8tA","link":"getApp_link__t5q45"};